<template>
    <rkm-area
        no-margin-top
        title="Listagem"
    >
        <rkm-table
            :fields="fields.tables.prontuariosUnidades"
            :items="items"
            ref="RkmTable"
        >
        </rkm-table>
    </rkm-area>
</template>

<script>

export default {
    computed: {
        fields() {
            return {
                tables: {
                    prontuariosUnidades: [
                        { key: 'prontuario', label: 'Prontuário da unidade', sortable: true },
                        { key: 'unidade.nomeFantasia', label: 'Unidade', sortable: true },
                    ]
                }
            }
        },
    },
    props: {
        items: { type: Array, required: true },
    }
}
</script>